import {debug} from "../utils";

export const ACTION_REPORTS_CHANGED = "ACTION_REPORTS_CHANGED"

export function ReportsPageReducer(state = {}, action) {
    switch (action.type) {
        case ACTION_REPORTS_CHANGED: {
            debug(`ReportsPageReducer ${ACTION_REPORTS_CHANGED} is being processed...`)
            return {...state, ...action.payload};
        }
        default:
            return state;
    }
}